import i18n from '../i18n';

type TranslateParams = Record<string, unknown>;

export function translateWithFallback(
    key: string,
    fallback: string,
    params?: TranslateParams
): string {
    // [2026-10-05] 先 te() 再 t()。这个函数**生来就是给"键可能不存在"的场景用的**
    //（每个调用点都自带 fallback），直接 t() 探测会落到 i18n.ts 的 missing 处理器，
    // 把「设计内的回落」喷成 `[i18n-CRITICAL-LEAK]` —— 医疗/报表引擎里几十处 tr(...)
    // 全都这样，真正的缺键被淹没在假告警里。
    if (!i18n.global.te(key)) return fallback;
    const value = params ? i18n.global.t(key, params as never) : i18n.global.t(key);
    if (typeof value !== 'string' || !value) return fallback;
    return value === key ? fallback : value;
}

/**
 * tFall — translate-with-fallback using the global i18n instance.
 *
 * Returns the translation for `key`, or `fallback` if the key is missing
 * (vue-i18n returns the key itself when no translation exists).
 *
 * This is the canonical helper. ~17 components previously inlined their own
 * copy of this logic with subtly different signatures; consolidate here.
 */
export function tFall(key: string, fallback = ''): string {
    // 同上：这是"取不到就回落"的语义，探键要用 te()，别用 t() 触发 CRITICAL-LEAK。
    return i18n.global.te(key) ? (i18n.global.t(key) as string) : fallback;
}

/**
 * tDesc — translate a description that MAY be an i18n dotted key.
 *
 * Only treats `desc` as a translation key when it contains a dot (the
 * convention for nested i18n paths like `studio.registry.figma`). If the
 * translation resolves to the input unchanged, return the original so a
 * plain-text description (e.g. "v1.2.3") is shown verbatim.
 */
export function tDesc(desc: string): string {
    if (!desc || !desc.includes('.')) return desc;
    // te() 探键；顺便要求解析结果真是字符串（键存在但值是对象时不能当文案用）。
    if (!i18n.global.te(desc)) return desc;
    const translated = i18n.global.t(desc);
    return typeof translated === 'string' && translated !== desc ? translated : desc;
}

// force HMR reload 2026年 08月 19日 星期三 12:29:23 CST
